<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="客户关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getCustomers">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addCustomer">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="customers" highlight-current-row v-loading="listLoading" style="width: 100%" @sort-change="sortchange" :height="bodyHeight-220">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="code" label="客户编码" min-width="120" sortable="custom">
      </el-table-column>
      <el-table-column prop="name" label="客户名称" min-width="150" sortable="custom">
      </el-table-column>
      <el-table-column prop="timeLimit" label="授权期限" width="120" sortable="custom" :formatter="formatdate">
      </el-table-column>
      <el-table-column prop="clientUserCount" label="客户端用户数" align="center" width="160" sortable="custom">
      </el-table-column>
      <el-table-column prop="phoneUserCount" label="手机端用户数" align="center" width="160" sortable="custom">
      </el-table-column>
      <el-table-column prop="esignResidueCount" label="E签宝剩余次数" align="center" width="160" sortable="custom">
      </el-table-column>      
      <el-table-column prop="serverName" label="所属服务器" width="140" sortable="custom">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center" :formatter="formatStatus" sortable="custom">
        <template scope="scope">
          <i :class="formatStatusIcon(scope.row)" @click="getTaskResult(scope.row)"></i>
          {{formatStatus(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建日期" width="180" sortable="custom" :formatter="formatdatetime">
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right">
        <template scope="scope">
          <el-button size="small" @click="editCustomer(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="delCustomer(scope.$index, scope.row)">删除</el-button>
          <el-dropdown @command="handleCommand">
            <el-button size="small">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{row:scope.row,command:'check'}">检查实例</el-dropdown-item>
              <el-dropdown-item :command="{row:scope.row,command:'rebuild'}">重新创建</el-dropdown-item>
              <el-dropdown-item :command="{row:scope.row,command:'viewlog'}">查看日志</el-dropdown-item>
              <el-dropdown-item :command="{row:scope.row,command:'enable'}">启用</el-dropdown-item>
              <el-dropdown-item :command="{row:scope.row,command:'disable'}">停用</el-dropdown-item>
              <el-dropdown-item :command="{row:scope.row,command:'esignrecharge'}">E签宝充值</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>

    <!--新增界面-->
    <el-dialog :title="customerTitle" :visible.sync="addFormVisible" :close-on-click-modal="false" size="small" top="10px">
      <div v-bind:style="{ height: (bodyHeight-165)+'px' , overflowY: 'auto' }">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
          <el-form-item label="所属服务器" prop="serverId">
            <el-select :loading="serverLoading" @change="serverChange" v-model.number="addForm.serverId" placeholder="所属服务器" style="width:100%">
              <el-option v-for="server in servers" :key="server.serverId" :label="server.serverName" :value="server.serverId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户编码" prop="code">
            <el-input v-model="addForm.code"></el-input>
          </el-form-item>
          <el-form-item label="客户名称" prop="name">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="授权期限" prop="timeLimit">
            <el-date-picker v-model="addForm.timeLimit" type="date"></el-date-picker>
          </el-form-item>
          <el-form-item label="客户端用户数" prop="clientUserCount">
            <el-input-number v-model="addForm.clientUserCount" min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="手机端用户数" prop="phoneUserCount">
            <el-input-number v-model="addForm.phoneUserCount" min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="服务器地址" prop="serverAddress">
            <el-input v-model="addForm.serverAddress">
              <el-select v-model="addForm.serverAddressPrefix" slot="prepend" size="large" placeholder="请选择">
                <el-option label="http://" value="http://"></el-option>
                <el-option label="https://" value="https://"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="服务期限" prop="serviceEndDate">
            <el-date-picker v-model="addForm.serviceEndDate" type="date"></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="addForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="saveCustomer" :loading="addLoading">保存</el-button>
        <el-button @click.native="addFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--E签宝充值-->
    <el-dialog title="E签宝充值" :visible.sync="addESignCountFormVisible" :close-on-click-modal="false" size="small" top="10px">
      <div v-bind:style="{ height: '200px' , overflowY: 'auto' }">
        <el-form :model="addESignCountForm" label-width="100px" :rules="addFormRules" ref="addESignCountForm">
          <el-form-item label="客户编码" prop="code">
            <el-input v-model="addESignCountForm.code" readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="客户名称" prop="name">
            <el-input v-model="addESignCountForm.name" readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="充值次数" prop="count">
            <el-input-number v-model="addESignCountForm.count" min="1"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addESignCount" :loading="addLoading">保存</el-button>
        <el-button @click.native="addESignCountFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--日志界面-->
    <el-dialog title="修改日志" :visible.sync="logVisible" :close-on-click-modal="false" size="small" top="10px">
      <el-table :data="customerChangeLogs" highlight-current-row v-loading="listLoading" style="width: 100%" @sort-change="sortchange" :height="bodyHeight-220">
        <el-table-column type="index" width="60">
        </el-table-column>
        <el-table-column prop="logContent" label="日志内容" sortable="custom">
        </el-table-column>
        <el-table-column prop="createDate" label="创建日期" width="180" sortable="custom" :formatter="formatdatetime">
        </el-table-column>
      </el-table>
    </el-dialog>

  </section>
</template>
<style>
  .el-input-group .el-select .el-input{
    width:90px;
  }
  i.Blue {
    color:#20A0FF
  }
  i.Success {
    color:#13CE66
  }
  i.Warning {
    color:#F7BA2A
  }
  /* .el-dialog__body {
    height: 600px;
    overflow-y:auto;
  } */
</style>

<script>
export default {
  name: 'customerManage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      listLoading: false,
      sortname: 'createdate',
      sorttype: 'desc',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      tableheight: window.innerHeight - 220,
      customers: [
      ],
      logVisible: false,
      customerTitle: '新增',
      isEditModel: false,
      addFormVisible: false, // 新增界面是否显示
      addESignCountFormVisible: false, // E签宝充值界面是否显示
      addLoading: false,
      addFormRules: {
        serverId: [
          { type: 'number', required: true, message: '请选择所属服务器', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入客户编码', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入客户名称', trigger: 'change' }
        ],
        serverAddress: [
          { required: true, message: '请输入服务器地址', trigger: 'change' },
          { validator: (rule, value, callback) => {
            if (this.addForm.serverAddressPrefix !== null && this.addForm.serverAddressPrefix !== '') {
              callback()
            } else {
              callback(new Error('请选择服务协议'))
            }
          },
            trigger: 'blur' }
        ],
        timeLimit: [
          { type: 'date', required: true, message: '请输入授权期限', trigger: 'change' }
        ],
        serviceEndDate: [
          { type: 'date', required: true, message: '请输入服务期限', trigger: 'change' }
        ]
      },
      // 新增界面数据
      addForm: {
        serverId: null,
        customerId: 0,
        code: '',
        name: '',
        timeLimit: '',
        clientUserCount: 0,
        phoneUserCount: 0,
        serverAddress: '',
        serverAddressPrefix: '',
        serviceEndDate: '',
        remark: ''
      },
      // E签宝充值界面数据
      addESignCountForm: {
        customerId: 0,
        code: '',
        name: '',
        count: 100
      },
      servers: [],
      serverLoading: false,
      customerChangeLogs: []
    }
  },
  methods: {
    formatdatetime: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    formatdate: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd')
    },
    // 显示转换
    formatStatus: function(row) {
      if (row.status === 0) {
        return '创建中'
      } else if (row.status === 1) {
        return '正常'
      } else if (row.status === 2) {
        return '停用'
      } else {
        return '未知'
      }
    },
    // 显示图标
    formatStatusIcon: function(row) {
      if (row.status === 0) {
        return 'el-icon-loading Blue'
      } else if (row.status === 1) {
        return 'el-icon-circle-check Success'
      } else if (row.status === 2) {
        return 'el-icon-warning Warning'
      } else {
        return 'el-icon-info'
      }
    },
    // 获取客户列表
    getCustomers: function() {
      let para = {
        keywords: this.filters.keywords,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }

      this.$ajax({
        url: 'api/Customer/GetCustomers',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.customers = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    pageChange: function(val) {
      this.pageno = val
      this.getCustomers()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getCustomers()
    },
    addCustomer: function() {
      this.customerTitle = '服务实例创建'
      this.isEditModel = false
      this.addFormVisible = true
      this.$ajax({
        url: 'api/Server/GetServers',
        method: 'get',
        data: {
          keywords: '',
          pageno: 1,
          pagesize: 100,
          sortname: '',
          sorttype: 'asc'
        },
        loadingName: 'serverLoading',
        success: (d) => {
          this.servers = d
        }
      })
      this.addForm = {
        serverId: null,
        customerId: 0,
        code: '-' + Math.floor(Math.random() * 99999998 + 1).toString(),
        name: '',
        timeLimit: new Date(),
        clientUserCount: 5,
        phoneUserCount: 5,
        serverAddress: '',
        serverAddressPrefix: null,
        serviceEndDate: new Date(),
        remark: ''
      }
      this.$refs.addForm.resetFields()
    },
    saveCustomer: function() {
      let url = ''
      if (this.addForm.customerId === 0) { // 创建
        url = 'api/Customer/CreateCustomer'
      } else {
        url = 'api/Customer/UpdateCustomer'
      }

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm)
          para.serverAddress = para.serverAddressPrefix + para.serverAddress + '/'
          this.$ajax({
            url: url,
            data: JSON.stringify(para),
            loadingName: 'addLoading',
            success: (response) => {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              })
              this.$refs['addForm'].resetFields()
              this.addFormVisible = false
              this.getCustomers()
            }
          })
        }
      })
    },
    serverChange: function(s, s1) {

    },
    editCustomer: function(index, row) {
      this.addFormVisible = true
      this.$ajax({
        url: 'api/Server/GetServers',
        method: 'get',
        data: {
          keywords: '',
          pageno: 1,
          pagesize: 100,
          sortname: '',
          sorttype: 'asc'
        },
        loadingName: 'serverLoading',
        success: (d) => {
          this.servers = d
        }
      }).then(() => {
        var reg = /^(https|http|ftp|rtsp|mms)?:\/\//
        this.customerTitle = '客户编辑'
        this.isEditModel = true
        this.addForm = Object.assign({}, row)
        let p = this.addForm.serverAddress.match(reg)
        this.addForm.serverAddressPrefix = (p != null ? p[0] : 'http://')
        this.addForm.serverAddress = this.addForm.serverAddress.replace(reg, '').replace(/(\/*$)/g, '')
        // this.addForm.status = this.addForm.status.toString()
        this.addForm.timeLimit = new Date(this.addForm.timeLimit)
        this.addForm.serviceEndDate = new Date(this.addForm.serviceEndDate)
        this.$refs.addForm.resetFields()
      })
    },
    delCustomer: function(index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = [row.customerId]
        this.$ajax({
          url: 'api/Customer/DeleteCustomers',
          data: JSON.stringify(para)
        }).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getCustomers()
        })
      }).catch(() => {
      })
    },
    openAddESignForm: function (row) {
      this.addESignCountFormVisible = true
      this.addESignCountForm = Object.assign({}, row)
      this.$refs.addESignCountForm.resetFields()
    },
    addESignCount: function () {
      let url = 'api/Customer/AddESignCount'
      let para = Object.assign({}, this.addESignCountForm)
      this.$ajax({
        url: url,
        data: JSON.stringify(para),
        loadingName: 'addLoading',
        success: (response) => {
          this.$message({
            message: '保存成功',
            type: 'success',
            duration: 1000
          })
          this.$refs['addESignCountForm'].resetFields()
          this.addESignCountFormVisible = false
          this.getCustomers()
        }
      })
    },
    handleCommand: function(command) {
      if (command.command === 'check') {
        this.check(command.row)
      } else if (command.command === 'rebuild') {
        this.rebuild(command.row)
      } else if (command.command === 'viewlog') {
        this.viewlog(command.row)
      } else if (command.command === 'disable') {
        this.disable(command.row)
      } else if (command.command === 'enable') {
        this.enable(command.row)
      } else if (command.command === 'esignrecharge') {
        this.openAddESignForm(command.row)
      }
    },
    check: function(row) {
      let para = row.customerId
      this.$ajax({
        url: 'api/Customer/Check?customerId=' + para,
        loadingName: 'listLoading',
        success: (d) => {
          if (d === '') {
            this.$message({
              message: '该实例正常',
              type: 'success'
            })
          } else {
            this.$message({
              message: d,
              type: 'warning'
            })
          }
        }
      })
    },
    rebuild: function(row) {
      let para = row.customerId
      this.$ajax({
        url: 'api/Customer/CreateInstance?customerId=' + para,
        loadingName: 'listLoading',
        success: (d) => {
          this.getCustomers()
        }
      })
    },
    viewlog: function(row) {
      let para = row.customerId
      this.logVisible = true
      this.$ajax({
        url: 'api/Customer/GetCustomerChangeLog?customerId=' + para,
        loadingName: 'listLoading',
        success: (d) => {
          this.customerChangeLogs = d
        }
      })
    },
    disable: function(row) {
      this.$confirm('确认要禁用该服务吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = row.customerId
        this.$ajax({
          url: 'api/Customer/DisableCustomer?customerId=' + para,
          loadingName: 'listLoading',
          success: (d) => {
            this.getCustomers()
          }
        })
      }).catch(() => {
      })
    },
    enable: function(row) {
      let para = row.customerId
      this.$ajax({
        url: 'api/Customer/EnableCustomer?customerId=' + para,
        loadingName: 'listLoading',
        success: (d) => {
          this.getCustomers()
        }
      })
    },
    getTaskResult: function(row) {
      let para = row.code + '_Create'
      this.$ajax({
        url: 'api/Customer/GetTaskResult?taskKey=' + para,
        loadingName: 'listLoading',
        success: (d) => {
          if (d === '') {
            this.$message({
              message: '该实例正常',
              type: 'success'
            })
          } else {
            this.$message({
              message: d,
              type: 'warning'
            })
          }
        }
      })
    }
  },
  mounted() {
    this.getCustomers()
    window.onresize = () => {
      return (() => {
        this.tableheight = window.innerHeight - 220
      })()
    }
  }
}
</script>
